import { useCallback, useContext } from "react";
import { ScopeOfWorkContext } from "../../../context/ScopeOfWorkContext";
import { useAppDispatch } from "src/redux/hooks/redux";
import { setTaskNoteInJobCreate } from "src/redux/features/jobCreateSlice";

export const useAreaActions = () => {
  const context = useContext(ScopeOfWorkContext);
  const reduxDispatch = useAppDispatch();
  const state = context?.state;
  const dispatch = context?.dispatch;

  const initialize = useCallback(
    (backendAreas: any[], squareFt: number) => {
      if (!dispatch) return;
      dispatch({
        type: "INITIALIZE_AREAS_FROM_BACKEND",
        payload: { areas: backendAreas, squareFt },
      });
    },
    [dispatch],
  );

  const changeQuantity = useCallback(
    (areaUid: string, delta: number) => {
      if (!dispatch) return;
      dispatch({
        type: "CHANGE_AREA_QUANTITY",
        payload: { areaUid, delta },
      });
    },
    [dispatch],
  );

  const toggleTask = useCallback(
    (areaUid: string, taskUid: string) => {
      if (!dispatch) return;
      dispatch({
        type: "TOGGLE_AREA_TASK_ACTIVE",
        payload: { areaUid, taskUid },
      });
    },
    [dispatch],
  );

  const setTaskNote = useCallback(
    (areaUid: string, taskUid: string, note: string) => {
      if (dispatch) {
        dispatch({
          type: "SET_TASK_NOTE",
          payload: { areaUid, taskUid, note },
        });
        return;
      }

      reduxDispatch(setTaskNoteInJobCreate({ areaUid, taskUid, note }));
    },
    [dispatch, reduxDispatch],
  );

  const removeOtherArea = useCallback(
    (areaUid: string) => {
      if (!dispatch) return;
      dispatch({ type: "REMOVE_OTHER_AREA", payload: { areaUid } });
    },
    [dispatch],
  );

  return {
    areas: state?.areas ?? [],
    otherAreas: state?.otherAreas ?? [],
    initialize,
    changeQuantity,
    toggleTask,
    setTaskNote,
    removeOtherArea,
  };
};
